<footer class="site-footer" role="contentinfo">
  <div class="footer-grid">
    <div class="footer-col footer-col--left">
      <div class="footer-logo">
        <a
          href="https://cfaes.osu.edu/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="The Ohio State University - College of Food, Agricultural, and Environmental Sciences"
        >
          <img
            src="/assets/img/brand/CFAES_Logo_Horiz_2C.svg"
            alt="The Ohio State University - College of Food, Agricultural, and Environmental Sciences"
          />
        </a>
      </div>

      <address class="footer-address">
        College of Food, Agricultural, and Environmental Sciences<br />
        Agricultural Administration Building<br />
        2120 Fyffe Road<br />
        Columbus, OH 43210
      </address>

      <div class="footer-contact">
        <a class="footer-link" href="mailto:cfaeswebmaster&#64;osu.edu">Contact Us</a>
        <a class="footer-link" href="tel:614-292-3676">614-292-3676</a>
      </div>
    </div>

    <div class="footer-col footer-col--right">
      <ul class="footer-social">
        @for (link of socialLinks; track link.label) {
          <li>
            <a [href]="link.url" target="_blank" rel="noopener noreferrer">
              <span class="visually-hidden">{{ link.label }} profile</span>
              <i [class]="link.icon" aria-hidden="true"></i>
            </a>
          </li>
        }
      </ul>

      <div class="footer-fine-print">
        <p class="footer-ada">
          If you have a disability and experience difficulty accessing this content,
          <a
            class="footer-link"
            href="https://osu.az1.qualtrics.com/jfe/form/SV_8eUHxEArVs87zDg"
            target="_blank"
            rel="noopener noreferrer"
            >please contact us</a
          >.
        </p>

        <div class="footer-links">
          <p>
            <a
              class="footer-link"
              href="https://go.osu.edu/privacy"
              target="_blank"
              rel="noopener noreferrer"
              >Privacy Statement</a
            >
          </p>
          <p>
            <a
              class="footer-link"
              href="https://go.osu.edu/non-discrimination-notice"
              target="_blank"
              rel="noopener noreferrer"
              >Non-discrimination Notice</a
            >
          </p>
          <p>
            <a
              class="footer-link"
              href="https://cfaes.osu.edu/notice-nondiscrimination"
              target="_blank"
              rel="noopener noreferrer"
              >USDA Non-Discrimination Statement</a
            >
          </p>
          <p>
            Page maintained by
            <a class="footer-link" href="mailto:kx&#64;osu.edu">CFAES Knowledge Exchange</a>.
          </p>
        </div>

        <div class="footer-copyright">&copy; {{ year }} The Ohio State University</div>
      </div>
    </div>
  </div>
</footer>
